import { FC } from "react"
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10 } from "../../../smallnation/partials/widgets"



const MergeCompany: FC = () => {
      const intl = useIntl()
      return (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Merge Company'})}</PageTitle>
          <TablesWidget10 className={""}/>
        </>
      )
    }
export {MergeCompany}